import type { DefineExamDefinitionInput, ReviseExamDefinitionInput } from "@repo/api/schemas";
import { asMemberId, isMemberId, type StoredExamDefinitionProps } from "@repo/domain";
import { deriveActivityDefinitionFields } from "../fhir/collections";
import { readExamDefinitionRow, writeExamDefinitionRow } from "../fhir/exam-definition-storage";
import type { ActivityDefinitionRow } from "../fhir/types";

function row(
  input: DefineExamDefinitionInput | ReviseExamDefinitionInput,
  mintedAt: string,
  prior?: ActivityDefinitionRow,
): ActivityDefinitionRow {
  const previous = prior ? readExamDefinitionRow(prior) : undefined;
  let mark = previous?.marks?.sections ?? 0;
  const facts: StoredExamDefinitionProps = {
    spine: {
      url: input.definitionUrl,
      name: previous?.spine.name ?? (input as DefineExamDefinitionInput).name,
      description: previous?.spine.description ?? (input as DefineExamDefinitionInput).description,
      version: (previous?.spine.version ?? 0) + 1,
      availability: previous?.spine.availability ?? "Active",
      mintedAt,
    },
    examNoteLabel: input.examNoteLabel,
    sections: input.sections.map((section) => ({
      ...section,
      id: isMemberId(section.id) ? section.id : asMemberId(`sec-${++mark}`),
    })),
    marks: { sections: mark },
  };
  const resource = writeExamDefinitionRow(facts, null);
  return {
    ...resource,
    id: `optimistic-exam-${input.definitionUrl}-${facts.spine.version}`,
    ...deriveActivityDefinitionFields(resource),
  };
}
export function optimisticDefinedExam(input: DefineExamDefinitionInput, mintedAt: string) {
  return row(input, mintedAt);
}
export function optimisticRevisedExam(
  prior: ActivityDefinitionRow,
  input: ReviseExamDefinitionInput,
  mintedAt: string,
) {
  return row(input, mintedAt, prior);
}
